import React from 'react'
import { AiFillCheckCircle } from 'react-icons/ai';
import { BiSolidPencil } from 'react-icons/bi';
import { CiSearch } from 'react-icons/ci';
import { RiArrowDropDownLine } from 'react-icons/ri';

const CampaignAudience: React.FC = () => {
  const [radio1, setRadio1] = React.useState(false);
  const [radio2, setRadio2] = React.useState(false);
  const [radio3, setRadio3] = React.useState(false);
  const [isActive, setIsActive] = React.useState<'Create new audience' | 'Use saved audience'>("Create new audience");
  const handleActive = (pageName: 'Create new audience' | 'Use saved audience') => {
    setIsActive(pageName);
  };

  const handleRadio1Change = () => {
    setRadio1(!radio1);
    setRadio2(false);
    setRadio3(false); // Uncheck other radios when radio1 changes
  };

  const handleRadio2Change = () => {
    setRadio2(!radio2);
    setRadio1(false);
    setRadio3(false); // Uncheck other radios when radio1 changes
  };

  const handleRadio3Change = () => {
    setRadio3(!radio3);
    setRadio2(false);
    setRadio1(false); // Uncheck other radios when radio1 changes
  };

  return (
    <div className="flex justify-center bg-white text-[#555] font-Poppins rounded-lg p-8 pb-16 flex-col shadow-[0px_4px_16px_0px_rgba(24,119,242,0.08)] ">
      <div className="flex gap-2 items-center">
        <AiFillCheckCircle className='fill-green-500'/>
        <h1 className='font-semibold text-lg'>Audience</h1>
      </div>
      <div className="pl-6 pr-12 font-normal">
        <p className='text-sm'>
          Define who you want to see your ads. 
          <span className='text-xs text-midGreen'>Learn more</span>
        </p>
      </div>
      <div className="flex gap-5 border-b border-b-[#ccc]  border-solid mt-5">
      <div
          className={`flex text-sm font-normal text-black pb-2 pl-2 cursor-pointer ${
            isActive && isActive === 'Create new audience' ? 'border-b-[3px] rounded-b-[3.53px] border-b-midGreen font-semibold' : ''
          }`}
          onClick={() => handleActive('Create new audience')}
        >
          Create new audience
        </div>
        <div 
          className={`flex text-sm font-normal text-black pb-2 cursor-pointer ${
            isActive && isActive === 'Use saved audience' ? 'border-b-[3px] rounded-b-[3.53px] border-b-midGreen font-semibold' : ''
          }`}
          onClick={() => handleActive('Use saved audience')}
        >
          Use saved audience
        </div>
      </div>
      <div className="grid mt-8">
        <div className="flex justify-between items-center">
          <h1 className='text-base font-semibold'>Custom Audiences</h1>
          <div className="flex gap-2 items-center">
            <h5 className='text-midGreen text-sm'>Create new</h5>
            <RiArrowDropDownLine size={28}/>
          </div>
        </div>
        <div className="relative mt-1">
          <input 
            type="text"
            placeholder='Search existing audiences'
            className='w-full h-11 pl-10 py-3 border-[#CCC] border-solid border rounded-lg placeholder:text-[#CCC] placeholder:font-Poppins placeholder:font-normal placeholder:text-xs' 
          />
          <div className="absolute left-3 top-4">
            <CiSearch className=" text-[#CCC]"/>
          </div>
          <p className='text-xs font-normal text-[#727272] mt-1'>
            We’ll schedule your ads based on the time zone
            of the person seeing it. For example, if you select 8am to 5pm,
            we’ll only show your ads to
            people from 8am to 5pm in their local time.
          </p>
          <div className="mt-5 w-32 justify-center items-center shadow-sm flex h-11 bg-[#CEC7F866] text-black rounded text-sm font-semibold">
            Exclude
          </div>
        </div>
      </div>

      <div className="flex justify-between mt-8">
        <div>
          <p className='text-base font-semibold mb-2'>* Locations</p>
          <li className='text-sm font-normal list-disc pl-1'>United States</li>
        </div>
        <div className="flex text-midGreen font-normal text-sm gap-2">
          <BiSolidPencil className='mt-[3px]' />
          Edit
        </div>
      </div>

      <div className="flex justify-between mt-8">
        <div>
        <p className='text-base font-semibold mb-2'>Age</p>
          <p className='text-sm font-normal'>18 - 65+</p>
        </div>
        <div className="flex text-midGreen font-normal text-sm gap-2">
          <BiSolidPencil className='mt-[3px]' />
          Edit
        </div>
      </div>

      <div className="flex justify-between mt-8">
        <div>
          <p className='text-base font-semibold mb-2'>Gender</p>
          <p className='text-sm font-normal'>All genders</p>
        </div>
        <div className="flex text-midGreen font-normal text-sm gap-2">
          <BiSolidPencil className='mt-[3px]' />
          Edit
        </div>
      </div>

      <div className="flex justify-between mt-8">
        <div>
          <p className='text-base font-semibold mb-2'>Detailed Targeting</p>
          <p className='text-sm font-normal'>All demographics, interests and behaviors</p>
        </div>
        <div className="flex text-midGreen font-normal text-sm gap-2">
          <BiSolidPencil className='mt-[3px]' />
          Edit
        </div>
      </div>

      <div className="flex justify-between mt-8 border-b-[#ccc] border-solid border-b pb-8">
        <div>
          <p className='text-base font-semibold mb-2'>Gender</p>
          <div className="flex">
            <input 
              type='radio' 
              id='r1' 
              className='accent-midGreen w-[18.5px] mr-1 cursor-pointer'
              checked={radio1}
              onChange={handleRadio1Change}
            />
            <label htmlFor="r1" className='text-sm font-semibold mr-3'>All</label>

            <input 
              type='radio' 
              id='r2' 
              className='accent-midGreen w-[18.5px] mr-1 cursor-pointer'
              checked={radio2}
              onChange={handleRadio2Change}
            />
            <label htmlFor="r2" className='text-sm font-semibold mr-3'>Men</label>

            <input 
              type='radio' 
              id='r3' 
              className='accent-midGreen w-[18.5px] mr-1 cursor-pointer'
              checked={radio3}
              onChange={handleRadio3Change} 
            />
            <label htmlFor="r3" className='text-sm font-semibold'>Women</label>
          </div>
        </div>
        <div className="flex text-midGreen font-normal text-sm gap-2">
          <BiSolidPencil className='mt-[3px]' />
          Edit
        </div>
      </div>

      <div className="flex justify-center mt-8 items-center bg-[#CEC7F866] text-black rounded h-11 w-52 text-sm font-semibold">
        Save this audience
      </div>
    </div>
  )
}

export default CampaignAudience;